"use client";

import Link from "next/link";
import { CartIcon, Logo7, SearchIcon, UserIcon } from "@/components/icons/assets";
import { useState, useEffect } from "react";
import { usePathname } from "next/navigation";
import MobileMenu from "./mobile-menu";
import { useAppSelector } from "@/store/hooks";
import { useCartDetail } from "@/components/hooks/use-cart-detail";

const menuItems = [
  { id: "1", path: "/", title: "Home" },
  { id: "2", path: "/products", title: "Products" },
  { id: "3", path: "/fitment", title: "Fitment" },
  { id: "4", path: "/installation", title: "Installation" },
  { id: "5", path: "/gallery", title: "Gallery" },
  { id: "6", path: "/contact", title: "Contact" },
];

function IconButtons({ className = "" }: { className?: string }) {
  useCartDetail();
  const cartDetail = useAppSelector((state) => state.cartDetail);
  const itemsQty = cartDetail?.cart?.itemsQty || 0;

  return (
    <>
      <button className={`cursor-pointer ${className}`}>
        <SearchIcon className="text-neutral-500" />
      </button>
      <button className={`cursor-pointer ${className}`}>
        <UserIcon className="h-6 w-6 text-neutral-500" />
      </button>
      <Link href="/add-to-cart" className={`flex items-center gap-1 cursor-pointer ${className}`}>
        <CartIcon className="h-6 w-6 text-neutral-500" />
        <span className="bg-neutral-500 text-white text-xs font-medium rounded-full px-2.5 py-0.5">
          {itemsQty}
        </span>
      </Link>
    </>
  );
}

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false)
  const pathname = usePathname();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10)
    }
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <nav
      className={`h-[76px] border-b border-stroke text-neutral-900 py-5 px-4 md:px-10 ${
        isScrolled 
          ? "top-0 bg-white shadow-lg" 
          : "top-auto bg-white"
      }`}
    >
      <div className="flex items-center justify-between">
        {/* Logo - always on left */}
        <Link href="/" className="flex items-center">
          <Logo7 className="" />
        </Link>
        {/* Desktop nav links - hidden on mobile */}
        <div className="hidden lg:flex items-center gap-8 text-neutral-500">
          {menuItems.map((item) => {
            const isActive = pathname === item.path;
            return (
              <Link
                key={item.id}
                href={item.path}
                className={`font-oswald font-medium text-base leading-[100%] tracking-[0.2px] text-center uppercase hover:text-primary transition-colors ${
                  isActive ? "text-primary" : ""
                }`}
              >
                {item.title}
              </Link>
            );
          })}
        </div>

        {/* Desktop Icons - hidden on mobile */}
        <div className="hidden lg:flex items-center gap-4 bg-white rounded-full px-4 py-2">
          <IconButtons />
        </div>

        {/* Mobile menu  */}
        <div className="lg:hidden">
          <MobileMenu 
            menu={menuItems} 
            renderIcons={() => <IconButtons className="text-neutral-700" />}
          />
        </div>
      </div>
    </nav>
  )
}

// export default async function Navbar() {
//   const menu = await getMenu(CACHE_KEY.headerMenus);
//   const menuData = [{ id: "", path: "/search", title: "All" }, ...menu];

//   return (
//     <header className="sticky top-0 z-10">
//       <nav className="relative flex flex-col items-center justify-between gap-4 bg-neutral-50 p-4 dark:bg-neutral-900 md:flex-row lg:px-6">
//         <div className="flex w-full items-center justify-between gap-0 sm:gap-4">
//           <div className="flex max-w-fit gap-2 xl:gap-6">
//             <Suspense fallback={null}>
//               <MobileMenu menu={menuData} />
//             </Suspense>
//             <Link
//               className="flex h-9 w-full scale-95 items-center md:h-9 md:w-auto lg:h-10"
//               href="/"
//             >
//               <LogoIcon />
//             </Link>
//             {menu.length ? (
//               <ul className="hidden gap-4 text-sm md:items-center lg:flex xl:gap-6">
//                 {menuData.slice(0, 3).map((item) => (
//                   <li key={item?.id + item.title}>
//                     <Link
//                       className="text-nowrap relative text-neutral-500 before:absolute before:bottom-0 before:left-0 before:h-px before:w-0 before:bg-current before:transition-all before:duration-300 before:content-[''] hover:text-black hover:before:w-full dark:text-neutral-400 dark:hover:text-neutral-300"
//                       href={`${item.path}`}
//                       prefetch={true}
//                     >
//                       {item.title}
//                     </Link>
//                   </li>
//                 ))}
//               </ul>
//             ) : null}
//           </div>
//           <div className="hidden justify-center md:flex">
//             <Suspense fallback={<SearchSkeleton />}>
//               <Search search={false} />
//             </Suspense>
//           </div>
//           <div className="flex max-w-fit gap-2 md:gap-4">
//             <MobileSearch />
//             <Suspense fallback={<OpenCart />}>
//               <div className="hidden lg:block">
//                 <ThemeSwitch />
//               </div>
//             </Suspense>
//             <Suspense fallback={<OpenCart />}>
//               <Cart />
//             </Suspense>
//             <Suspense fallback={<OpenCart />}>
//               <UserAccount />
//             </Suspense>
//           </div>
//         </div>
//       </nav>
//     </header>
//   );
// }
